import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import moment from "moment";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validateEmail } from "../utils/utils";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import controllerLocal from "../locales/duck";

const { Text } = Inputs;

function AddContacto({ history, match }) {
  const dispatch = useDispatch();

  const modelUpdateContacto = useSelector((state) => state.updateContacto);
  const modelContactoById = useSelector((state) => state.getContactoById);
  const modelLocal = useSelector((state) => state.localById);

  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [documento, setDocumento] = useState("");
  const [direccion, setDireccion] = useState("");
  const [email, setEmail] = useState("");
  const [ts, setTs] = useState(moment().format("YYYY-MM-DD"));
  const [localId, setLocalId] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [camposContacto, setCamposContacto] = useState(null);

  useEffect(() => {
    dispatch(controller.getContactoByIdThunk({ id: match.params.id }));
  }, []);

  useEffect(() => {
    const data = modelUpdateContacto?.data?.data;
    const error = modelUpdateContacto?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckUpdateContacto.actions.clear());
    }
    if (data) {
      history.push(`/contactos/${localId}`);
      dispatch(controller.duckUpdateContacto.actions.clear());
    }
  }, [modelUpdateContacto]);

  useEffect(() => {
    const data = modelContactoById?.data?.data;
    const error = modelContactoById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckContactoById.actions.clear());
    }
    if (data) {
      setNombre(data.data.nombre);
      setTelefono(data.data.telefono);
      setDocumento(data.data.documento);
      setDireccion(data.data.direccion);
      setEmail(data.data.email);
      setTs(data.data.ts);
      setLocalId(data.data.localId);
      if (data.data.fechaNacimiento) {
        setFechaNacimiento(new Date(data.data.fechaNacimiento));
      }
      dispatch(controllerLocal.localByIdThunk(data.data.localId));
      dispatch(controller.duckContactoById.actions.clear());
    }
  }, [modelContactoById]);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
   

      if (data.data.detalles.camposContacto) {
        setCamposContacto(data.data.detalles.camposContacto);
      }

      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  function submit() {
    if (
      camposContacto?.fechaNacimiento?.habilitado &&
      camposContacto?.fechaNacimiento?.required
    ) {
      alert("Por favor ingrese una fecha de nacimiento");
      return;
    }
    if (
      camposContacto?.direccion?.habilitado &&
      camposContacto?.direccion?.required
    ) {
      alert("Por favor ingrese una direccion");
      return;
    }
    if (camposContacto?.email?.habilitado && camposContacto?.email?.required) {
      alert("Por favor ingrese un email");
      return;
    }
    if (email && !validateEmail(email)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }

    if (
      camposContacto?.telefono?.habilitado &&
      camposContacto?.telefono?.required
    ) {
      alert("Por favor ingrese un numero de telefono");
      return;
    }
    if (!nombre || !documento) {
      alert("Por favor ingrese el nombre y documento");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    let data = {
      id: match.params.id,
      nombre,
      telefono,
      documento,
      ts,
      direccion,
      email,
      localId,
      fechaNacimiento,
    };

    dispatch(controller.updateContactoThunk(data));
  }

  return (
    <Content title="Nuevo contacto" browserTitle="Nuevo contacto" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo contacto"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelUpdateContacto.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Documento" obligatorio={true} />}
              value={documento}
              onChange={(evt) => setDocumento(evt.target.value)}
            />
            {camposContacto?.telefono?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.telefono?.required ? (
                    <Etiqueta texto="Telefono" obligatorio={true} />
                  ) : (
                    "Telefono"
                  )
                }
                value={telefono}
                inputType="number"
                onChange={(evt) => setTelefono(evt.target.value)}
              />
            ) : null}

            {camposContacto?.email?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.email?.required ? (
                    <Etiqueta texto="Email" obligatorio={true} />
                  ) : (
                    "Email"
                  )
                }
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
              />
            ) : null}

            {camposContacto?.direccion?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.direccion?.required ? (
                    <Etiqueta texto="Direccion" obligatorio={true} />
                  ) : (
                    "Direccion"
                  )
                }
                value={direccion}
                onChange={(evt) => setDireccion(evt.target.value)}
              />
            ) : null}
            {camposContacto?.fechaNacimiento?.habilitado ? (
              <div style={{ marginBottom: 15 }}>
                <label>
                  {camposContacto?.fechaNacimiento?.required ? (
                    <Etiqueta texto="Fecha de nacimiento" obligatorio={true} />
                  ) : (
                    "Fecha de nacimiento"
                  )}
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  customInput={<input type="text" className="form-control" />}
                  selected={fechaNacimiento}
                  onChange={(date) => {
                  
                    setFechaNacimiento(date);
                  }}
                />
              </div>
            ) : null}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddContacto;
